<template>
<div>
    <v-server-table v-if="!savedFilterId || (savedFilterId && savedFilter)" ref="incidentTable" url="/incident/list" :columns="columns" :options="options">

        <router-link slot="IncidentId" slot-scope="props" :to="`/incidents/view/${props.row.IncidentId}`" title="View Incident" class="btn btn-sm btn-light">
            View - {{ props.row.IncidentId }}
        </router-link>

        <template slot="EmpLastName" slot-scope="props">
            <router-link :to="`/employees/view/${props.row.EmployeeId}`" title="View Employee">
                {{ props.row.EmpFirstName }} {{ props.row.EmpLastName }}

            </router-link>
            <template v-if="props.row.additional_employees && props.row.additional_employees.length > 0">
                + {{ props.row.additional_employees.length }} More
            </template>
        </template>

        <template slot="user_id" slot-scope="props">
            {{ props.row.first_name }} {{ props.row.last_name }}
        </template>

        <template slot="IncidentDate" slot-scope="props">
            {{ props.row.IncidentDate | moment("MM/DD/YYYY") }}
        </template>

        <template slot="status_name" slot-scope="props">
            <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
        </template>

        <template slot="JobsiteName" slot-scope="props">
            <router-link :to="`/jobsites/view/${props.row.JobsiteId}`" title="View Jobiste" v-if="props.row.JobsiteId">
                {{ props.row.JobsiteName }}
            </router-link>
            <span title="Non-Jobsite Location" v-else>
                {{ props.row.other_location }}
            </span>
        </template>

        <template slot="created_at" slot-scope="props">
            {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
        </template>

        <template slot="child_row" slot-scope="props">
            <div class="mb-2">
                <label class="text-muted">Additional Employees:</label>
                <template v-if="!props.row.additional_employees || props.row.additional_employees.length == 0">
                    --
                </template>
                <template v-else>
                    <span v-for="(emp, key) in props.row.additional_employees">
                        <template v-if="key > 0">, </template>
                        <router-link :to="`/employees/view/${emp.EmployeeId}`">{{ emp.FirstName }} {{ emp.LastName }}</router-link>
                    </span>
                </template>

            </div>
            <div class="mb-2">
                <label class="text-muted">Detailed Description</label>
                <div v-html="props.row.DetailedDescription"></div>
            </div>

        </template>
    </v-server-table>
</div>
</template>

<script>
export default {
    props: ['timeFilter', 'savedFilterId'],

    data: function() {
        return {
            exportingTable: false,
            savedFilter: null,
            userTimezone: this.$store.state.user.timezone,
            columns: ['IncidentId', 'EmpLastName', 'IncidentDate', 'status_name', 'IncidentTypeName', 'InjuryTypeName', 'DivisionName', 'JobsiteName', 'JobsiteNumber', 'user_name', 'created_at'],
            options: {
                headings: {
                    IncidentId: 'ID',
                    EmpLastName: 'Employee',
                    IncidentDate: 'Incident Date',
                    status_name: 'Status',
                    total_cost: 'Total',
                    IncidentTypeName: 'Type',
                    InjuryTypeName: 'Injury',
                    DivisionName: 'Division',
                    JobsiteName: 'Jobsite',
                    JobsiteNumber: 'Jobsite#',
                    user_name: 'Creator',
                    created_at: 'Created'
                },
                orderBy: {
                    ascending: false,
                    column: 'incident.IncidentDate',
                },
                responseAdapter: (response) => {
                    //Emit the count
                    this.$emit('incidentListCount', response.data.count);

                    //Send it
                    return response.data;
                },
                requestAdapter: (data) => {
                    if(this.savedFilter)
                    {
                        //Get the config
                        var tableConfig = JSON.parse(this.savedFilter.table_config);

                        data.limit = (tableConfig.limit ? tableConfig.limit : 25);
                        data.query = tableConfig.query;
                        data.orderBy = tableConfig.orderBy;
                        data.ascending = tableConfig.ascending;

                        data.filters = this.extractFilters();
                    }
                    else
                    {
                        //Set the filters
                        data.filters = {
                            'incident.IncidentDate': this.timeFilter.toLowerCase(),
                        };
                    }

                    this.getPreviousData();

                    //Send it
                    return data;
                },
                uniqueKey: 'IncidentId',
            },
        }
    },

    methods: {
        refresh: function() {
            this.$refs.incidentTable.refresh();
        },

        getPreviousData: function() {
            let filters = null;
            if(this.savedFilter)
            {
                filters = this.extractFilters();
                // Only these specific date filters have previous data
                if (!filters['incident.IncidentDate'] || (filters['incident.IncidentDate'].split(':')[0] != 'rolling' && filters['incident.IncidentDate'] != 'mtd' && filters['incident.IncidentDate'] != 'ytd'))
                {
                    this.$emit('prevIncidentListCount', undefined);
                    return;
                }
                filters['incident.IncidentDate'] = 'prev_'+filters['incident.IncidentDate'];
            }
            else
            {
                //Set the filters
                filters = {
                    'incident.IncidentDate': 'prev_'+this.timeFilter.toLowerCase(),
                };
            }

            this.$http.get('/incident/list', {'filters': filters})
            .then(response => {
                this.$emit('prevIncidentListCount', response.data.count);
            })
            .catch(err => {

            })
            .then(() => {

            });
        },

        extractFilters: function() {
            let filters = {
                'incident.IncidentTypeId': [],
                'incident.InjuryTypeId': [],
                'jobsite.DivisionId': [],
                'incident.IncidentDate': "",
                'incident.JobsiteId': {},
            };

            let table_filters = JSON.parse(this.savedFilter.table_filters);

            for (var i = 0; i < table_filters['incident.IncidentTypeId'].length; i++) {
                //Add each id
                filters['incident.IncidentTypeId'].push(table_filters['incident.IncidentTypeId'][i]['id']);
            }

            for (var i = 0; i < table_filters['incident.InjuryTypeId'].length; i++) {
                //Add each id
                filters['incident.InjuryTypeId'].push(table_filters['incident.InjuryTypeId'][i]['id']);
            }

            for (var i = 0; i < table_filters['jobsite.DivisionId'].length; i++) {
                //Add each id
                filters['jobsite.DivisionId'].push(table_filters['jobsite.DivisionId'][i]['id']);
            }

            filters['incident.IncidentDate'] = table_filters['incident.IncidentDate'];

            var jobsite = table_filters['incident.JobsiteId'];
            filters['incident.JobsiteId'] = jobsite && jobsite.hasOwnProperty('JobsiteId') ? jobsite['JobsiteId'] : null;

            return filters;
        },
    },

    mounted() {
        if (this.savedFilterId)
        {
            for(let i = 0; i < this.$store.state.user.filters.length; i++)
            {
                if (this.$store.state.user.filters[i].id == this.savedFilterId)
                {
                    this.savedFilter = this.$store.state.user.filters[i];
                    break;
                }
            }
        }
    }
}
</script>
